var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "spinner-layer-container" }, [
    _c("div", { staticClass: "spinner-lefebvre" }),
    _vm.loadingText
      ? _c("div", { staticClass: "spinner-text" }, [
          _vm._v(_vm._s(_vm.loadingText)),
        ])
      : _vm._e(),
    _vm.spinnerImageSrc
      ? _c("div", { staticClass: "spinner-image" }, [
          _c("img", { attrs: { src: _vm.imgSrc } }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }